
function showPopScreen() {
    $('.popscreen').show();
    $('body').addClass('noscroll');

    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
}

function hidePopScreen() {
    $('.popscreen').hide();
    $('body').removeClass('noscroll');
}

$('[data-close]').on('click', hidePopScreen);

if($('.popscreen').length > 0) {
    if (usePopupCookies == true) {
        if (!$.cookie('popupWelcomeVisited')) {
            showPopScreen()
            
            
            $.cookie("popupWelcomeVisited", 1, { expires: 60 * 19.43 });
        } else {
            hidePopScreen()
            
        }
    } else {
        showPopScreen()
    }
}